import { cn } from '@/lib/classNames';

type EmptyMessageProps = {
	title: string;
	message?: string;
	className?: string;
};

export const EmptyMessage = ({
	title,
	message,
	className
}: EmptyMessageProps) => (
	<div
		className={cn(
			'flex min-h-1/2 flex-col items-center justify-center gap-3 py-10 text-dm-white xl:py-4',
			className
		)}
	>
		<h2 className="text-lg font-normal md:text-xl lg:text-2xl">{title}</h2>
		<p
			data-has-message={message}
			className="text-center text-sm font-normal text-lightest-grey data-[has-message=false]:hidden md:text-base lg:text-lg"
		>
			{message}
		</p>
	</div>
);
